var _line, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 24,
    viewBox: "0 0 76 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    y1: 13.5,
    x2: 76,
    y2: 13.5,
    stroke: "#11302D",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5952 22.7825H29.4044C28.2246 22.7825 27.1287 22.1716 26.5085 21.1679C25.8881 20.1643 25.8317 18.911 26.3594 17.8556L34.9548 3.13969C35.5316 1.98646 36.7103 1.25781 37.9998 1.25781C39.2893 1.25781 40.468 1.98646 41.0448 3.13969L49.6401 17.8556C50.1679 18.911 50.1114 20.1643 49.491 21.1679C48.8708 22.1716 47.7751 22.7825 46.5952 22.7825V22.7825Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5974 22.7828H38V1.25812C39.2926 1.25006 40.4761 1.98164 41.0466 3.14164L49.6398 17.857C50.1683 18.9117 50.1126 20.165 49.4927 21.1685C48.8727 22.1723 47.7772 22.7832 46.5974 22.7828V22.7828Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6553 19.0573C39.6553 19.9718 38.9138 20.7131 37.9994 20.7131C37.085 20.7131 36.3438 19.9718 36.3438 19.0573C36.3438 18.1429 37.085 17.4016 37.9994 17.4016C38.9138 17.4016 39.6553 18.1429 39.6553 19.0573Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6558 19.0573C39.6558 19.4965 39.4815 19.9176 39.171 20.2283C38.8603 20.5387 38.4392 20.7131 38 20.7131V17.4016C38.4392 17.4014 38.8603 17.5758 39.171 17.8865C39.4815 18.1969 39.6558 18.6182 39.6558 19.0573Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9994 4.56934C38.9138 4.56934 39.6553 5.31062 39.6553 6.22518V14.0899C39.6553 15.0043 38.9138 15.7455 37.9994 15.7455C37.085 15.7455 36.3438 15.0043 36.3438 14.0899V6.22518C36.3438 5.31062 37.085 4.56934 37.9994 4.56934V4.56934Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6558 6.22518V14.0899C39.6558 14.5291 39.4815 14.9502 39.171 15.2607C38.8603 15.5714 38.4392 15.7457 38 15.7456V4.56934C38.4392 4.56879 38.8609 4.74298 39.1715 5.05363C39.482 5.36429 39.6564 5.78576 39.6558 6.22518V6.22518Z",
    fill: "#2C3E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningline);
export default __webpack_public_path__ + "static/media/warningline.d05a2dca8775434fe36a9ccfed0b4109.svg";
export { ForwardRef as ReactComponent };